import { useTheme } from '@mui/material/styles';

function NRJiraLowPriorityIcon({ height = '24', width = '24', color }) {
  const theme = useTheme();
  const iconColor = color || theme.palette.jiraIntegration?.priorityColors?.low;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M6 10L12 14L18 10" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default NRJiraLowPriorityIcon;
